/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { Link, useNavigate } from "react-router-dom";

/* Helpers, constants, custom methods, internal libraries */
import { dateFormatWithLocale, currencyFormatWithLocale } from '../../../../../helpers/general';

/* Components */
import UCGrid from "../../../../ucgrid";
import ReportsNoMileage from "../../../../reportsNoMileage"
import { useLocaleContext } from '../../../../../contexts/localeContext';

/* Styles */
import styles from "./styles.js"


const SpendGrid = (props) => {
  const {gridOptions, setGridOptions, mileageResponse, onRowClick} = props;
  const theme = useTheme();
  const classes = styles({ theme });
  const navigate = useNavigate();
  const locale = useLocaleContext();

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <div className={classes.spendGrid}>
      <UCGrid
        gridName="spendGrid"
        data={ mileageResponse?.results }
        columns={ mileageResponse?.columns }
        actions={ mileageResponse?.actions }
        handlePageChange={(page) => {setGridOptions({
          ...gridOptions,
          page
        });
        page > 1 ? navigate(`/app/reports/spend?page=${page}`) : navigate(`/app/reports/spend`)
        }}
        setSelectedRow={setSelectedRow}
        spinner="spendGridSpinner"
        customColumns={{
          bookingDate: (row) => (
            dateFormatWithLocale(row.bookingDate, locale)
          ),
          checkInDate: (row) => (
            dateFormatWithLocale(row.checkInDate, locale)
          ),
          checkOutDate: (row) => (
            dateFormatWithLocale(row.checkOutDate, locale)
          ),
          estimatedTotalAfterTax: (row) => (
            currencyFormatWithLocale(row.estimatedTotalAfterTax, locale, row.currency)
          ),
          estimatedTotalBeforeTax: (row) => (
            currencyFormatWithLocale(row.estimatedTotalBeforeTax, locale, row.currency)
          ),
          nightlyRate: (row) => (
            currencyFormatWithLocale(row.nightlyRate, locale, row.currency)
          )
        }}
        columnCustomWidth={{
          estimatedTotalBeforeTax: "290px !important",
          estimatedTotalAfterTax: "290px !important",
          nightlyRate : "200px !important",
          travelerName : "200px !important",
          teamName: "200px !important",
        }}
        noDataComponent={ <ReportsNoMileage descriptionId="reportsNoMileage.description.spend.CHOICE"/> }
        showHeader={true}
        persistTableHead={false}      
        onRowClick={onRowClick}
      />
    </div>
  )
}

export default SpendGrid;
